<template lang="pug">
v-row.criteria-selector.flex-nowrap(align="center")
  v-col(cols="2", v-if="showLogicalOperator")
    v-select(
      :items="logicalOperators"
      v-model="logicalOperator"
      item-text="label"
      item-value="value"
      :error-messages="errors[path + '.value']",
      v-show="!hideLogicalOperator"
    )
  v-col(cols="3")
    app-entity-path-selector(
      v-show="operator != 'custom expression'",
      ref="path-selector",
      :entity="criteriaEntity",
      @path="ppath = $event.path; field = $event.field",
      :initial="instance && instance.value && ppath"
      :error-messages="errors[path + '.value']",
    )
  v-col.flex-shrink-1(cols="2")
    v-select.operator(
      :items="operators",
      v-model="operator",
      :error-messages="errors[path + '.value']",
    )
  v-col.flex-shrink-1(:cols="!isVisible && !isDimension? null : 5")
    foo-field(
      v-if="field && operator != 'custom expression'",
      :entity="criteria",
      :field="field",
      :label="label",
      :type="type",
      v-model="getValue",
      :inputValue="getValue",
      @change="input($event )",
      @input="input($event)",
      :error-messages="errors[path + '.value']",
    )

    slot(v-else)
      v-text-field(
      v-if="operator == 'custom expression'",
      v-model="value",
      :error-messages="errors[path + '.value']",
    )
  v-col.flex-shrink-1(cols="4", v-if="isDimension")
    v-text-field(
      label="Save as"
      v-model="label"
    )
  v-col.criteria__actions(cols="auto")
    v-btn(
      icon,
      x-small,
      @click="erase",
    )
      v-icon(color="primary") mdi-eraser
    v-btn(
      icon,
      x-small,
      @click="reset",
    )
      v-icon(color="primary") mdi-close
</template>

<style lang="scss" scoped>
.criteria-selector {
  ::v-deep .v-input__append-inner .v-input__icon--append .v-icon {
    color: var(--v-primary-base);
  }
}
</style>

<script>
import EntityMixin from '@/mixins'
export default {
  mixins: [EntityMixin],
  props: {
    parent: Object,
    entity: Object,
    path: String,
    criteriaEntityName: String,
    // onlySelect: Boolean,
    initialCriterias: Array,
    relation: Object,
    fromList: Boolean,
    elementIndex: null,
    visibleIndex: null,
  },
  data () {
    return {
      name: '',
      value: null,
      criterias: [...(this.initialCriterias || [])],
      operator: '=',
      logicalOperators: [{label: 'AND', value: '&&'}, {label: 'OR', value: '||'}],
      ppath: null,
      field: null,
      label:null,
      logicalOperator: null,
      hideLogicalOperator: false,
    }
  },
  watch: {
    criteria (value) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.entity', value: this.criteriaEntityEnvName } )
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.value', value } )
    },
    label(value) {
      let stringValue = value ? String(value) : value;
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.label', value: stringValue } )
    },
    operator(value) {
      const customExpressionFlag = value === 'custom expression' ? true : false;
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '.isCustomExpression', value: customExpressionFlag });

      this.hideLogicalOperator = customExpressionFlag;
    },
    field(value) {
      if(value.type === 'Bool' && !this.value) this.value = false;
    },
  },
  methods: {
    reset() {
      this.$emit('close', this.instance);
    },
    erase() {
      this.$refs['path-selector'].reset()
      this.name = ''
      this.ppath = null
      this.field = null
      this.value = null
      this.operator = '='
      this.label = null
      this.logicalOperator = null
    },
    notify(criteria) {
      //this.$emit('criteria', criteria || this.criteria)
    },
    isCustomExpression(criteria){
      if (!criteria) return false;
      var pieces = criteria.split(' ')
      if(pieces.length > 1)
        return false
      return true
    },
    isContainsExpression(criteria) {
      if(!criteria) return false;
      return /\.Contains\(/.test(criteria);
    },
    isInOrNotInExpression(criteria) {
      if(!criteria) return false;
      return /\[\]/.test(criteria);
    },
     input ($event) {
       if(this.type === 'Bool' || this.type === 'Boolean')
       {
          this.value = $event === null ? false : $event;
       }
    },
  },
  computed: {
    operators() {
      return [
        { text: '=', value: '=' },
        { text: '>=', value: '>=' },
        { text: '<=', value: '<=' },
        { text: '!=', value: '!=' },
        { text: this.$t('Criteria.optionContains'), value: 'Contains' },
        { text: this.$t('Criteria.optionCustomExpression'), value: 'custom expression' },
        { text: this.$t('Criteria.containedIn'), value: "in" },
        { text: this.$t('Criteria.notContainedIn'), value: "not in" },
      ];
    },
    criteriaEntityEnvName () {
      return this.criteriaEntityName ||
        (
          this.parent &&
          ENV.ENTITIES[this.parent.name] &&
          ENV.ENTITIES[this.parent.name].entityForCriteria
        )
        || this.$store.state.criteriaEntityName
    },
    criteriaEntity () {
      return this.$findEntity(this.criteriaEntityEnvName) || this.entity
    },
   type () {
      return this.field
        ? this.field.type === 'Guid'
          ? 'String'
            : this.field.type === 'DateTimeOffset' 
            ? 'Datetime' : this.field.type
        : undefined
    },
    criteria () {

      //If the criteria is a custom expression, send it as it is
      // NOTE: this means that users has to provide the logical operator here too.
      if (this.operator === 'custom expression')
        return this.value

      let lOperator = this.logicalOperator ? `${this.logicalOperator} ` : '';

      if (this.operator === 'Contains' && (this.field || {}).type === 'String')
        return `${lOperator}${this.ppath}.Contains(${this.escapedValue})`

      //Build the sentence when using the IN/NOT IN operator. Creates an expression of type:
      // && !(new[]{"Value1", "Value2", "Value3"}.Contains(Fieldname.Value))
      if ((this.operator === 'in' || this.operator === 'not in') && (this.field || {}).type === 'String')
      {
        var negationMark = this.operator === 'not in' ? '!' : '';
        return `${lOperator}${negationMark}(new[]{${this.cleanValue}}.Contains(${this.ppath}))`;
      }

      return `${lOperator}${this.ppath} ${this.operator} ${this.escapedValue}`
    },
    cleanValue() {
      if(this.value && typeof this.value === 'string')
      {
        var cleanString = this.value.replace(/, "/g, ',"');
        cleanString = cleanString.replace(/" ,/g, '",').trim();

        //Check if final char is a comma, remove if is
        if(cleanString.charAt(cleanString.length-1) == ',')
           cleanString = cleanString.substring(0, cleanString.length-1);

        //Check if all quote marks are closed properly
        if(cleanString.match(/"/g).length % 2 != 0)
        {
          const lastQuoteMarks = cleanString.lastIndexOf('"');
          cleanString = cleanString.substring(0, lastQuoteMarks-1);
        }

        return cleanString;
      }
      else
        return '';
    },
    escapedValue() {
      if (this.value && this.type != "Bool") {
        if(this.value.startsWith("\"") && this.value.endsWith("\""))
          return this.value
                return this.type === "String" ? `"${this.value}"` : this.value
      }
      else if(this.type === 'Bool')
      {
        return this.value;
      }
    },
    errors() {
      return this.$store.state.errors;
    },
    isDimension() {
      return _.get(this.relation, 'name') === 'dimensions';
    },
    showLogicalOperator() {
      return this.fromList && this.isVisible && !this.isDimension;
    },
    isVisible() {
      return Boolean(this.visibleIndex && this.visibleIndex !== -1);
    },
    getValue: {
      get () {
        if (this.type == "Bool") {
          return String(this.value) == "true";
        }
        else {
          return this.value;
        }
      },
      set (v) {
        this.value = v;
      }
      
    }
  },
  created () {
    if (this.instance && this.instance.value) {
      if(this.instance.isCustomExpression) {
        this.operator = 'custom expression'
        this.value = this.instance.translatedValue
      } else if (this.isContainsExpression(this.instance.value) && !this.isInOrNotInExpression(this.instance.value)) {
        let pieces = this.instance.value.split(' ')
        this.operator = 'Contains';
        let containsValue = this.instance.value;
        if (pieces.length == 2) {
          this.logicalOperator = pieces[0];
          containsValue = pieces[1];
        }

        // Exec function https://developer.mozilla.org/es/docs/Web/JavaScript/Reference/Global_Objects/RegExp/exec
        // Returns array with first element being all parts that the regex evaluates
        // Second element to n returns sub strings captured by the regex ()'s
        let regexInfo = /([\S]*)\.Contains\("([\S\s]*)"\)/.exec(containsValue);
        let [, foundPath, foundValue ] = regexInfo;
        this.ppath = foundPath;
        this.value = foundValue;
      }
      else if(this.isInOrNotInExpression(this.instance.value))
      {
        var firstChars = this.instance.value.substring(0,2);
        this.logicalOperator = (firstChars === '&&' || firstChars === '||') ? firstChars : '';
        this.operator = this.instance.value.includes('!(') ? 'not in' : 'in';
        this.value = this.instance.value.substring(
            this.instance.value.indexOf("{") + 1,
            this.instance.value.lastIndexOf("}")
        );
        this.ppath = this.instance.value.substring(
          this.instance.value.indexOf(".Contains(") + 10,
          this.instance.value.lastIndexOf("))")
        );

      }
      else {
        var pieces = this.instance.value.split(' ')
        if(this.showLogicalOperator){
          this.logicalOperator = pieces[0];
          this.ppath = pieces[1]
          this.operator = pieces[2]
          this.value = pieces[3]
          for(var i = 4; i < pieces.length; i++){
             this.value += ' ' + pieces[i]
          }
        }
        else{
          this.ppath = pieces[0]
          this.operator = pieces[1]
          this.value = pieces[2]
          for(var i = 3; i < pieces.length; i++){
             this.value += ' ' + pieces[i]
          }
        }
      }
      this.label = (this.instance || {}).label;
    }
    else if(!this.value && this.type === 'Bool')
    {
      this.value = false;
    }
  },
}
</script>
